import { FormattedMessage } from 'react-intl';

import DefaultHedgeType from '@/App/UserPreferences/OptionTab/DefaultHedgeType.tsx';
import DefaultPriceType from '@/App/UserPreferences/OptionTab/DefaultPriceType.tsx';
import OptionAlignCurrencies from '@/App/UserPreferences/OptionTab/OptionAlignCurrencies.tsx';
import OptionExpandGreekAndMkt from '@/App/UserPreferences/OptionTab/OptionExpandGreekAndMkt.tsx';
import OptionOneWayQuotation from '@/App/UserPreferences/OptionTab/OptionOneWayQuotation.tsx';
import OptionStrategyGroupLegs from '@/App/UserPreferences/OptionTab/OptionStrategyGroupLegs.tsx';

export const OptionTab = () => {
  return (
    <div className="overflow-y-auto">
      <p className="mt-1 mb-2">
        <FormattedMessage id="userPreferences.section.displayPreferences" />
      </p>

      <div className="border">
        {/* useless remove in forex */}
        {/* <ShowDeltaStrike />
        <OptionDisplayMidVolatility /> */}
        <OptionOneWayQuotation />
        <OptionExpandGreekAndMkt />
      </div>

      <p className="mt-4 mb-2">
        <FormattedMessage id="userPreferences.section.default" />
      </p>

      <div className="border">
        <DefaultPriceType />
        <DefaultHedgeType />
        <OptionStrategyGroupLegs />
      </div>

      <p className="mt-4 mb-2">
        <FormattedMessage id="userPreferences.section.behaviourPreferences" />
      </p>

      <div className="border">
        <OptionAlignCurrencies />
      </div>
    </div>
  );
};
